import { render, staticRenderFns } from "./WattageDetail.vue?vue&type=template&id=a9627876"
import script from "./WattageDetail.vue?vue&type=script&lang=js"
export * from "./WattageDetail.vue?vue&type=script&lang=js"
import style0 from "./WattageDetail.vue?vue&type=style&index=0&id=a9627876&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports